export default __webpack_public_path__ + "static/default-hero-a4d7cd7dbfb9e8d002eb499820cd8cbc.jpg";